<template>
    <div class="left-menu-block-wrapper">
        <div class="left-menu-block-inner">
            <ul class="left-menu user-menu">
                <AdminNavigationItems/>
            </ul>
        </div>
    </div>
</template>



<script>

    import AdminNavigationItems from "./AdminNavigationItems";

    export default {
        name: 'AdminNavigation',

        components: {AdminNavigationItems}
    }
</script>